import { useEffect } from 'react'; // <-- 1. Added useEffect here
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import './css/main-style.min.css';
import './css/style.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from './component/Home';
import Header from './component/layout/Header';
import Footer from './component/layout/Footer';
import About from './component/About';
import Page404 from './component/layout/Page404';
import Services from './component/Services';
import Servicedetail from './component/Servicedetail';
import Scrolltop from './component/layout/Scrolltop';
import Manufacturing from './component/Manufacturing';
import Client from './component/Client';
import Contact from './component/Contact';
import Faq from './component/Faq';
import Career from './component/Career';
import Terms from './component/Terms';
import Privacy from './component/Privacy';
import Products from './component/Products';
import Productdetail from './component/Productdetail';
import Blog from './component/Blog';
import Blogdetail from './component/Blogdetail';
import Blogcategory from './component/Blogcategory';
import Categories from './component/Categories';
import Category from './component/Category';
import Management from './component/Management';
import Managementdetail from './component/Managementdetail';
import Investorsection from './component/Investorsection';
function App() {

useEffect(() => {
    // 1. Block Right-Click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // 2. Block Copy Shortcut (Ctrl+C / Cmd+C)
    const handleCopy = (e) => {
      e.preventDefault();
    };

    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('copy', handleCopy);

    // Clean up event listeners on unmount
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('copy', handleCopy);
    };
  }, []);


  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
        <Scrolltop/>
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/manufacturing' element={<Manufacturing />} />
            <Route path='/clients' element={<Client />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/faq' element={<Faq />} />
            <Route path='/careers' element={<Career />} />
            <Route path='/terms-and-conditions' element={<Terms />} />
            <Route path='/privacy-policy' element={<Privacy />} />
            <Route path='/services' element={<Services />} />
            <Route path='/service/:alias' element={<Servicedetail />} />
            <Route path='/products' element={<Products />} />
            <Route path='/product/:alias' element={<Productdetail />} />            
            <Route path='/blogs' element={<Blog />} />
            <Route path='/blog/:alias' element={<Blogdetail />} /> 
            <Route path='/blog-category/:alias' element={<Blogcategory />} /> 
            <Route path='/categories' element={<Categories />} />
            <Route path='/category/:alias' element={<Category />} />
            <Route path='/board-of-directors' element={<Management type='board' />} />
            <Route path='/leadership-team' element={<Management type='leadership' />} />
            <Route path='/board-of-directors/:alias' element={<Managementdetail />} />
            <Route path='/management-team' element={<Navigate to='/board-of-directors' replace />} />
            <Route path='/investors/:alias' element={<Investorsection />} />

            <Route path='/*' element={<Page404 />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}
export default App;